import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DatePipe } from '@angular/common';
import { PipesModule } from './pipes/pipes.module';

import { CookieService } from 'angular2-cookie/services/cookies.service';
import {
    JYoguiSharedLibsModule,
    JYoguiSharedCommonModule,
    CSRFService,
    AuthService,
    AuthServerProvider,
    AccountService,
    UserService,
    TimeZoneService,
    StateStorageService,
    LoginService,
    BackOfficeService,
    LoginModalService,
    Principal,
    JhiTrackerService,
    HasAnyAuthorityDirective,
    JhiLoginModalComponent
} from './';

@NgModule({
    imports: [
        JYoguiSharedLibsModule,
        JYoguiSharedCommonModule,
        PipesModule
    ],
    declarations: [
        JhiLoginModalComponent,
        HasAnyAuthorityDirective
    ],
    providers: [
        CookieService,
        LoginService,
        BackOfficeService,
        LoginModalService,
        AccountService,
        StateStorageService,
        Principal,
        CSRFService,
        JhiTrackerService,
        AuthServerProvider,
        AuthService,
        UserService,
        TimeZoneService,
        DatePipe
    ],
    entryComponents: [JhiLoginModalComponent],
    exports: [
        JYoguiSharedCommonModule,
        JhiLoginModalComponent,
        HasAnyAuthorityDirective,
        DatePipe,
        PipesModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class JYoguiSharedModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/shared.module.ts